// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ignore-readonly[data-v-c457e716] {\n    background-color: #fff !important;\n}\n", ""]);
// Exports
module.exports = exports;
